import {
  convertToByte2t4hntblnhq2k as convertToByte,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.byteArrayOf' call
  return new Int8Array([convertToByte(_this__u8e3s4), convertToByte(shiftRight(_this__u8e3s4, 8)), convertToByte(shiftRight(_this__u8e3s4, 16)), convertToByte(shiftRight(_this__u8e3s4, 24)), convertToByte(shiftRight(_this__u8e3s4, 32)), convertToByte(shiftRight(_this__u8e3s4, 40)), convertToByte(shiftRight(_this__u8e3s4, 48)), convertToByte(shiftRight(_this__u8e3s4, 56))]);
}
//region block: exports
export {
  toByteArray as toByteArray1inlj2pk87rey,
};
//endregion

//# sourceMappingURL=Long.ext.mjs.map
